import { render } from "./dealerstatement_form.vue?vue&type=template&id=5b202e8c&scoped=true"
import script from "./dealerstatement_form.vue?vue&type=script&lang=js"
export * from "./dealerstatement_form.vue?vue&type=script&lang=js"

import "./dealerstatement_form.vue?vue&type=style&index=0&id=5b202e8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b202e8c"]])

export default __exports__